export default "__VITE_ASSET__5yPPXqFQ__"